export enum TimeIntervalType {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
}
